import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

function AdminLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { darkMode } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [appVersion, setAppVersion] = useState('loading...');

  // Fetch version from server
  useEffect(() => {
    fetch('/api/version')
      .then(res => res.json())
      .then(data => setAppVersion(data.version))
      .catch(() => setAppVersion('unknown'));
  }, []);

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const closeSidebar = () => setSidebarOpen(false);

  // Redirect non-admin/owner users
  if (user && user.role !== 'admin' && user.role !== 'owner') {
    navigate('/dashboard');
    return null;
  }

  return (
    <div className="main-layout">
      <button
        className="hamburger-btn"
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2 style={{ color: '#dc2626' }}>Admin Panel</h2>
          <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: darkMode ? '#9ca3af' : '#6b7280' }}>
            System Management
          </p>
        </div>

        <nav className="sidebar-nav">
          <Link
            to="/admin"
            className={isActive('/admin') ? 'active' : ''}
            onClick={closeSidebar}
          >
            <span>📊</span> Dashboard
          </Link>

          <Link
            to="/admin/users"
            className={isActive('/admin/users') ? 'active' : ''}
            onClick={closeSidebar}
          >
            <span>👥</span> Users
          </Link>

          <Link
            to="/admin/audit"
            className={isActive('/admin/audit') ? 'active' : ''}
            onClick={closeSidebar}
          >
            <span>📋</span> Audit Log
          </Link>

          <Link
            to="/admin/health"
            className={isActive('/admin/health') ? 'active' : ''}
            onClick={closeSidebar}
          >
            <span>💚</span> System Health
          </Link>

          <Link
            to="/admin/backups"
            className={isActive('/admin/backups') ? 'active' : ''}
            onClick={closeSidebar}
          >
            <span>💾</span> Backups
          </Link>

          {user?.role === 'owner' && (
            <Link
              to="/admin/crm"
              className={isActive('/admin/crm') ? 'active' : ''}
              onClick={closeSidebar}
            >
              <span>📇</span> CRM
            </Link>
          )}

          <div style={{ borderTop: `1px solid ${darkMode ? '#374151' : '#e2e8f0'}`, margin: '15px 0' }}></div>

          <Link
            to="/dashboard"
            onClick={closeSidebar}
          >
            <span>🔙</span> Back to App
          </Link>
        </nav>

        <div className="sidebar-footer">
          <div style={{ marginBottom: '15px', fontSize: '14px' }}>
            <div style={{ color: darkMode ? '#9ca3af' : '#6b7280' }}>Admin</div>
            <div style={{ color: darkMode ? 'white' : '#1f2937', fontWeight: '500' }}>
              {user?.first_name} {user?.last_name}
            </div>
            <div style={{ color: darkMode ? '#9ca3af' : '#6b7280', fontSize: '12px' }}>{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-secondary"
            style={{ width: '100%' }}
          >
            Sign Out
          </button>
          <div style={{ marginTop: '15px', textAlign: 'center', fontSize: '11px', color: darkMode ? '#6b7280' : '#9ca3af' }}>
            v{appVersion}
          </div>
        </div>
      </div>

      <div className="main-content">
        {children}
      </div>
    </div>
  );
}

export default AdminLayout;
